import { useSelector } from 'react-redux';

import { ICommentsState } from '../interfaces/comments';
import { getCommentsError, getCurrentArticleComments, getCurrentArticleTotalComments } from '../selectors/comments';

export function useCurrentArticleComments(articleId): ICommentsState | undefined {
  return useSelector(getCurrentArticleComments(articleId));
}

export function useCommentsError(articleId): string {
  return useSelector(getCommentsError(articleId));
}

export function useTotalComments(articleId): number | undefined {
  return useSelector(getCurrentArticleTotalComments(articleId));
}
